import type { Conference } from "../funnel/conferences";
import { logAction, type LogTarget } from "./actionLog";
import { slotLabel } from "./labels";

/**
 * ═══ CE QUE LE CLIC SUR UN CRÉNEAU CHANGE ═══
 *
 * La même route (`placeSlot`) fait trois gestes : un créneau retenu se rend
 * (désinscription, 44), un créneau libre se prend (inscription, 43), et pris dans une
 * conférence où l'on avait déjà une place, il RENDRAIT l'ancienne : deux lignes, car la
 * place rendue peut partir aussitôt chez quelqu'un d'autre.
 *
 * ⚠️ À LIRE AVANT L'ÉCRITURE, sur la liste affichée : après, le cache relu ne dit plus
 * quel créneau était le sien.
 */
export type SlotChange = {
  action: "conferenceRegistration" | "conferenceUnregistration";
  label: string;
};

export function slotChanges(conferences: readonly Conference[], slotId: number): SlotChange[] {
  const conference = conferences.find((c) => c.slots.some((s) => s.id === slotId));
  if (!conference) return [];
  const slot = conference.slots.find((s) => s.id === slotId)!;
  const label = (start: string) => slotLabel(conference.title, start);
  if (slot.selected) return [{ action: "conferenceUnregistration", label: label(slot.start) }];
  return [
    ...conference.slots
      .filter((s) => s.selected)
      .map((s) => ({ action: "conferenceUnregistration" as const, label: label(s.start) })),
    { action: "conferenceRegistration", label: label(slot.start) },
  ];
}

/** `userId` : la fiche de l'accompagnant, quand c'est pour lui que le porteur choisit. */
export function logSlotChanges(
  target: LogTarget | null | undefined,
  changes: readonly SlotChange[],
  userId?: number,
): void {
  for (const change of changes) logAction(target, change.action, { userId, label: change.label });
}
